
import {
getRoster,
getMessageList,
getMessageHistoryList,
sendMessage,
readAllMessage,
getNewestMessageList,
sendMessageType
} from "@/common/js/api.js";
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'


export default {
components: {
Tab,
TabItem,
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Scroller,
Icon,
Sticky
},
methods: {













nav(idx) {
this.$router.push({
path: "/love/detail",
query: { newsId: this.list[idx].newsId }
});
},
refresh() {
let self = this;
if (this.loadAll) {
setTimeout(function() {
self.$refs.scroller.donePulldown();
}, 200);
} else {
self.pageInfo.pageIndex++;
self.loadMore();
}
},
loadMore() {
let self = this;
self.pageInfo.pageIndex++;
self.loadMore();
},
switchTabItem(index) {

this.$vux.loading.show({
span: "loading"
});
setTimeout(() => {
this.$vux.loading.hide();
this.index01 = index;
}, 1000);
},
onItemClick(index) {
console.log("on item click:", index);
},
getList() {
let self = this;
getNewsList({ data: this.pageInfo }).then(function(data) {
self.div.firstLoad = false;
if (data.PageIndex > 1) {
self.list = self.list.concat(data.Content);
} else {
self.list = data.Content;
}
if (data.Content.length == self.pageInfo.pageSize) {
self.$refs.scroller.enablePullup();
} else {
self.$refs.scroller.disablePullup();
}
setTimeout(() => {
self.$refs.scroller.donePullup();
self.$refs.scroller.donePulldown();
}, 50);
});
},
getMessageList() {
let self = this;
getMessageList({ data: this.pageInfo }).then(function(data) {
for(let i=0;i<data.Content.length;i++){
if(data.Content[i].messageType==2){
data.Content[i].content = JSON.parse(data.Content[i].content);
}
}
self.dataSource = data.Content.reverse();



setTimeout(function() {
var ele = document.getElementById("chat-body");

document.documentElement.scrollTop = ele.scrollHeight;
}, 200);
});
},
getMessageHistoryList() {
let self = this;
getMessageHistoryList({
data: {
receiver: this.receiver,
beforeTime: self.dataSource[0].sendTimeStamp
}
}).then(function(data) {
if (data.Content.length < 10) {
self.loadAll = true;
self.usePulldown = false;

}
self.dataSource = data.Content.reverse().concat(self.dataSource);


});
},
getRoster() {
let self = this;
getRoster({ receiver: self.receiver }).then(function(data) {
self.roster = data.Content;
if (self.roster.name) {



document.title = self.roster.name;
}

self.getMessageList();
});
},
readAllMessage() {
let self = this;
readAllMessage({ receiver: self.receiver }).then(function(data) {

});
},
getNewestMessageList() {
let self = this;




getNewestMessageList({
data: {
receiver: self.receiver,
lastTime: self.lastTime
}
}).then(function(data) {
self.lastTime = data.Message;
if (data.Content.length > 0) {
self.dataSource = self.dataSource.concat(data.Content.reverse());





setTimeout(function() {
var ele = document.getElementById("chat-body");
document.documentElement.scrollTop = ele.scrollHeight;
}, 200);
}
});
if (self.isShow) {
setTimeout(function() {
self.getNewestMessageList();
}, 2000);
}
},
loadMore() {
let self = this;
if (self.dataSource.length == 0) {
return;
}
self.getMessageHistoryList();
},
sendMessage() {
let self = this;
if (!self.message) {
self.$vux.toast.span("发送内容不能为空哦~", "middle");
return;
}
let msg = {};
msg.receiver = self.receiver;
msg.content = self.message;
sendMessage({ data: msg }).then(
function(data) {
self.message = "";
},
function(data) {
self.$vux.toast.span(data);
}
);
},
init(){
let receiver = this.$route.query.receiver;
let self = this;
if (receiver) {
this.receiver = receiver;
} else {
this.receiver = "1";
}
this.pageInfo.extInfo.receiver = this.receiver;

self.getRoster();

this.readAllMessage();
setTimeout(function() {
self.getNewestMessageList();
}, 3000);
this.isShow = true;
}
},

mounted() {
let self = this;
if (this.$route.query.type && this.$route.query.id) {
let msg = {};
msg.objectType = this.$route.query.type;
msg.objectId = this.$route.query.id;
sendMessageType({ data: msg }).then(function(){
self.init();
})
}
else{
this.init();
}


},
activated() {

console.log("activated");
},
destroyed: function() {
this.isShow = false;
},
data() {
return {
div: {
loading: false,
firstLoad: true
},
status: {
pullupStatus: "default",
pulldownStatus: "default"
},
pullupConfig: {
content: "上拉加载更多",
downContent: "松开进行加载",
upContent: "上拉加载更多",
loadingContent: "加载中..."
},
pulldownConfig: {
content: "下拉刷新",
downContent: "下拉刷新",
upContent: "释放刷新",
loadingContent: "加载中..."
},
pageInfo: {
pageIndex: 1,
pageSize: 10,
keyword: "",
extInfo: {}
},
title: "",
disabled:
typeof navigator !== "undefined" &&
/iphone/i.test(navigator.userAgent) &&
/ucbrowser/i.test(navigator.userAgent),
list: [],
dataSource: [],
receiver: "",
roster: {},
message: "",
lastTime: "",
scrollTop: 999999,
loadAll: false,
isShow: false,
usePulldown: true
};
}
};



// WEBPACK FOOTER //
// ./src/components/chat/chat.vue